import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import './App.scss';
import Header from './components/header/Header';
import PageGreeting from './pages/greeting/PageGreeting';
// import PageFirstLogin from './pages/firstLogin/PageFirstLogin';
// import PageDismissRegistration from './pages/dismissRegistration/PageDismissRegistration';
import PageLogin from './pages/login/PageLogin';
import PageContact from './pages/contact/PageContact';
import PageContactVienna from './pages/contact/contactVienna/PageContactVienna';
import PageContactBudapest from './pages/contact/contactBudapest/PageContactBudapest';
import PageContactKoper from './pages/contact/contactKoper/PageContactKoper';
import PageHome from './pages/home/PageHome';
import PageInvoices from './pages/invoices/PageInvoices';
// import PageStocks from './pages/stocks/PageStocks';
import PageSettings from './pages/settings/PageSettings';
import PageTracking from './pages/tracking/PageTracking';
import PageTrackingSystem from "./pages/tracking/trackingSystem/PageTrackingSystem";
import PageYusenVantage from "./pages/tracking/yusenVantage/PageYusenVantage";
import PageRegister from "./pages/register/PageRegister";
import PageUnsubscribe from './pages/unsubscribe/PageUnsubscribe';
// import LoginData from './components/repository/LoginData';
import { urlSearchParams_GET } from "./repository/globals";
import useMain from "./common/MainContext";

function App() {
  const { loginData } = useMain();

  const currentSearchParams = urlSearchParams_GET();

  function setActivity() {
    if (loginData) {
      loginData.setLastActivity();
    }
  }

  debugger

  let routerType = '';
  if (currentSearchParams?.func) {
    switch (currentSearchParams.func) {
      case 'register': routerType = 'register'; break;
      case 'unsubscribe': routerType = 'unsubscribe'; break;
      default: routerType = 'login'; break;
    }
  } else {
    routerType = (!loginData) ? 'notLogged' : 'logged';
  }

  if (routerType === 'register') {
    return (
      <PageRegister
        currentSearchParams={currentSearchParams}
      />
    )
  }

  if (routerType === 'unsubscribe') {
    return (
      <PageUnsubscribe
        currentSearchParams={currentSearchParams}
      />
    )
  }

  return (
    <div className="App" onMouseDown={setActivity} onKeyDown={setActivity}>
      <BrowserRouter>
        <Header />
        <Routes>
          {routerType === 'register' &&
            <PageRegister />
            // <>
            //   <Route path="/register" element={<PageRegister />} />
            //   <Route path="*" element={<Navigate to="/register" />} />
            // </>
          }
          {routerType === 'unsubscribe' &&
            <PageUnsubscribe />
            // <>
            //   <Route path="/unsubscribe" element={<PageUnsubscribe />} />
            //   <Route path="*" element={<Navigate to="/unsubscribe" />} />
            // </>
          }
          {routerType === 'notLogged' &&
            <>
              <Route path="/" element={<PageGreeting />} />
              <Route path="/login" element={<PageLogin />} />
              <Route path="*" element={<Navigate to="/" />} />
            </>
          }
          {routerType === 'logged' &&
            <>
              <Route path="/home" element={<PageHome />} />
              <Route path="/invoices" element={<PageInvoices />} />
              <Route path="/settings" element={<PageSettings />} />
              <Route path="/tracking" element={<PageTracking />} />
              <Route path="/tracking/trackingsystem" element={<PageTrackingSystem />} />
              <Route path="/tracking/yusenvantage" element={<PageYusenVantage />} />
              <Route path="*" element={<Navigate to="/home" />} />
              <Route path="/contact" element={<PageContact />} />
              <Route path="/contact/budapest" element={<PageContactBudapest />} />
              <Route path="/contact/koper" element={<PageContactKoper />} />
              <Route path="/contact/vienna" element={<PageContactVienna />} />
            </>
          }
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
